import { memo } from "react";
import { FieldTypeEditorProps } from "../types";

export const CountrySelectFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => null,
);
